module.exports = __webpack_public_path__ + "static/media/fm.2d1657d1.svg";